import { CasesDashboard } from "@/components/CaseJobs/CaseJobs";
import { LoadLinks } from "@/links";

export const HomePage = () => {
  const { PrimaryLinks, FooterLinks } = LoadLinks();

  return <CasesDashboard primaryLinks={PrimaryLinks} footerLinks={FooterLinks} />;
};
